<div class="border-card border-0 px-4 py-1 scroll-container" ref="manage_workflow">
  <NavigationBackButton />

  <div class="card card-nav-tabs mt-5 rounded-lg border-0 shadow p-1">
    <div class="card-header card-header-primary shadow-2 rounded-lg">
      <div class="nav-tabs-navigation">
        <div class="nav-tabs-wrapper">
          <ul class="nav nav-tabs" data-tabs="tabs">
            <li class="nav-item">
              <a class="text-white text-decoration-none text-x nav-link p-0" data-toggle="tab">
                Preview signed contract
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div v-if="contract_status === 'pending'">
        <div class="mt-5 contract-preview-wrapper">
          <iframe
            src="https://www.orimi.com/pdf-test.pdf"
            class="w-100 border-0 contract-preview-frame">
          </iframe>
        </div>

        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
          <button type="button" class="btn btn-primary-dark btn-sm px-3 shadow text-xxs" @click="approve_contract">Proceed</button>
          <button type="button" class="btn bg-danger text-white btn-sm px-3 shadow text-xxs" data-bs-toggle="modal" data-bs-target="#reject_contract">Reject</button>
        </div>
      </div>

      <div v-else>
        <div class="text-dark text-center mt-3 mb-5">
          <p class="mb-1 text-x fw-bold" :class="{'text-success': contract_status === 'approved', 'text-danger': contract_status === 'rejected'}">
            {{ contract_status === 'approved' ? 'Contract Approved!' : 'Contract Rejected!' }}
          </p>
          <p class="mb-0 text-xxs">
            {{ contract_status === 'approved'
              ? 'The contract has been successfully approved and moves to the next step.'
              : 'The contract has been rejected and cannot proceed to the next stage.' }}
          </p>
        </div>

        <div class="lead-status-timeline mt-3">
          <div class="status-progress">
            <div v-for="(step, step_index) in steps" :key="step_index" class="status-step">
              <div
                :class="['circle', step_index < current_step ? 'completed' : '', step_index === current_step ? 'current' : '', step_index > current_step ? 'pending' : '']">
                <i v-if="step_index < current_step" class="bi bi-check-lg"></i>
                <i v-else class="bi bi-dot"></i>
              </div>
              <div class="label">{{ step }}</div>
              <div
                v-if="step_index < steps.length - 1"
                :class="['line', step_index < current_step - 1 ? 'line-completed' : '', step_index === current_step - 1 ? 'line-current' : '', step_index >= current_step ? 'line-pending' : '']">
              </div>
            </div>
          </div>
        </div>

        <div class="card bg-white rounded-lg shadow p-4 text-xxs mt-4">
          <p><strong>Contract Title:</strong> {{ contract_details.title }}</p>
          <p><strong>Date Sent:</strong> {{ contract_details.date_sent }}</p>
          <p><strong>Date Received:</strong> {{ contract_details.date_received }}</p>
          <p>
            <strong>Current Status:</strong>
            <span
              class="badge ms-2"
              :class="{
                'bg-green-dark text-dark': contract_status === 'approved',
                'bg-danger': contract_status === 'rejected'
              }"
            >
              {{ contract_status === 'approved' ? '✓ APPROVED' : '✗ REJECTED' }}
            </span>
          </p>

          <p v-if="contract_status === 'rejected'" class="text-danger mt-2 mb-0">
            <strong>Rejection Reason:</strong> {{ rejection_reason }}
          </p>
          <div class="d-flex justify-content-end">
            <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow-sm text-dark">Preview Contract</button>
          </div>
        </div>

        <p class="text-muted text-end mt-4 text-xxs">
          Action completed on {{ contract_details.completed_at }} by {{ contract_details.completed_by }}
        </p>
      </div>
    </div>
  </div>
</div>


<!-- Reject Modal -->
<teleport to="body">
  <div class="modal fade" id="reject_contract" tabindex="-1" aria-labelledby="reject_contract_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs" id="create_project_label">Reject Contract</p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="modal-form-group form-group mb-2 d-flex flex-column">
            <label for="request_info_note" class="modal-form-label form-label text-start text-xxs">Reason for rejection</label>
            <textarea
              v-model="rejection_reason"
              id="request_info_note"
              class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
              rows="4"
              placeholder="Please provide a clear reason for rejecting this contract...">
            </textarea>
          </div>
        </div>
        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-primary-dark btn-sm px-3 shadow text-xxs"
            @click="reject_contract(rejection_reason)">
            Send Rejection
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>